export default __webpack_public_path__ + "static/You-Wont-Believe-These-Countries-Have-the-Fastest-WIFI-9048ae67580d62df3910f63867330752.jpg";